import { AbstractControl, ValidationErrors } from '@angular/forms';

import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import { createAlphaValidator } from './alpha.validator';
import { Converter } from '@app/shared/utils/converter';
import { AllowedCharsOptions } from '@app/shared/forms/dynamic-form/fields.service';
import {
  FakeFormControl,
  SpecialValidatorFnFactory,
} from '@app/shared/utils/special-validators/special-validators.model';

export const createAlphaExtendedValidator: SpecialValidatorFnFactory = function (options: AllowedCharsOptions) {
  return function (control: AbstractControl | FakeFormControl): ValidationErrors | null {
    const value = control.value;
    let valid = true;
    let regExp;
    const empty = ''; //String.empty()

    if (options && options.allowedChars) {
      // building replacer regexp due to
      // user input may contain any special character breaking regular expression. We should avoid that
      const regExpSpecChars = '.^$*+?()[{\\|^-]';
      let escaped = Converter.Strings.htmlDecode(options.allowedChars) // decode
        .split(empty) // to array
        .map((char) => {
          // escape spec chars
          if (regExpSpecChars.indexOf(char) !== -1) {
            char = '\\' + char;
          }
          return char;
        })
        .join(empty); // make string again
      escaped = Converter.Strings.htmlEncode(escaped);
      regExp = new RegExp('[' + escaped + ']', 'gi');
    }

    if (value) {
      let result = value;
      if (regExp) {
        result = value.replace(regExp, empty);
      }
      valid = createAlphaValidator()({ value: result }) === null;
    }

    return valid ? null : { [SpecialValidationType.AlphaConfigurable]: { value } };
  };
};
